import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/browser';
import type { Event, EventHint } from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp;
  const {
    public: { sentry: sentryConfig },
  } = useRuntimeConfig();

  Sentry.init({
    app: [vueApp],
    dsn: sentryConfig.config.dsn,
    environment: sentryConfig.config.environment,
    release: sentryConfig.config.release,
    integrations: [
      new BrowserTracing({
        ...(useRouter()
          ? { routingInstrumentation: Sentry.vueRouterInstrumentation(useRouter(), { routeLabel: 'path' }) }
          : {}),
      }),
    ],
    sampleRate: sentryConfig.config.sampleRate,
    tracesSampleRate: sentryConfig.config.tracesSampleRate,
    maxBreadcrumbs: 25,
    beforeSend(event: Event, _hint: EventHint) {
      const value = event?.exception?.values?.[0];
      if (
        value &&
        value.type === 'EvalError' &&
        value?.stacktrace?.frames?.[0]?.filename &&
        value.stacktrace.frames[0].filename.toLowerCase().includes('_incapsula_resource')
      ) {
        return null;
      }
      // Continue sending to Sentry
      return event;
    },
  });

  vueApp.mixin(
    Sentry.createTracingMixins({ trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] }),
  );
  Sentry.attachErrorHandler(vueApp, {
    logErrors: false,
    attachProps: true,
    trackComponents: true,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update'],
  });

  return {
    provide: {
      sentry: {
        setContext: Sentry.setContext,
        setUser: Sentry.setUser,
        setTag: Sentry.setTag,
        addBreadcrumb: Sentry.addBreadcrumb,
        captureException: Sentry.captureException,
      },
    },
  };
});
